var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',{attrs:{"cmpt":"LoadingRow"}},[_c('Column',{attrs:{"width":_vm.left}}),_c('Column',{class:_vm.classes(),attrs:{"showBorder":_vm.showBorder,"width":_vm.middle}},[_c('img',{attrs:{"src":require("@/assets/2022/ReadyChekAnimatedLoading.gif"),"width":_vm.imageWidth()}}),_vm._t("default")],2),_c('Column',{attrs:{"width":_vm.right}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }